import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection, SECTION_DESIGN_TYPE, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces";
import { IHoverElement, useLandingStore } from "src/modules/pe-landing-module/data/store";
import updateHistory from "../utils/updateHistory";

export default function globalChange( makeupType: any, hoverElement : IHoverElement | undefined, preset: any ): void {
    // if( !hoverElement ) return
    const currentLanding: ILanding = useLandingStore.getState().currentLanding
    let step:IHistoryStep, newValue: any
    switch( makeupType ) {
        case SELECT_TYPE.HACCORDEON:            
        case SELECT_TYPE.ACCORDEON:            
            //console.log(makeupType, hoverElement, preset)   
            newValue = JSON.parse( JSON.stringify( 
                {
                    ...currentLanding,
                    sections: currentLanding.sections.map((section: ILandingSection) => {
                        if(section.designType === SECTION_DESIGN_TYPE.HACCORDEON) {
                            return {
                                ...section,
                                haccordeon_design: preset
                            }
                        }
                        return section
                    }) 
                } 
            ))
            step = {
                data: newValue,
                prevData: currentLanding,
                type: HISTORY_TYPE.FULL,
                title: `Change global ${makeupType}`
            }
            updateHistory(step, newValue)
            return
        case SELECT_TYPE.DELIMITER:
        case SELECT_TYPE.DESCRIPTION:
        case SELECT_TYPE.TITLE:
        default:
            newValue = {
                ...currentLanding,
                [ makeupType ]: preset
            }
            step = {
                data: newValue,
                prevData: currentLanding[ makeupType as keyof ILanding ],
                type: HISTORY_TYPE.SETTINGS,
                title: `Change global ${ makeupType }`
            }
            updateHistory(step, newValue)
            return
    }
}